const MAX_LATITUDE = 90
const MAX_LONGITUDE = 180

/**
 * Valid map coordinates of a crash, or null when missing or out of range.
 * @param {{ Longitude?: unknown, Latitude?: unknown }|null} crash
 * @returns {{ longitude: number, latitude: number }|null}
 */
export function getCrashCoordinates(crash) {
  const longitude = Number(crash?.Longitude)
  const latitude = Number(crash?.Latitude)
  const isMissing = crash?.Longitude == null || crash?.Latitude == null || crash.Longitude === '' || crash.Latitude === ''
  if (isMissing || !Number.isFinite(longitude) || !Number.isFinite(latitude)) return null
  if (Math.abs(latitude) > MAX_LATITUDE || Math.abs(longitude) > MAX_LONGITUDE) return null
  return { longitude, latitude }
}
